import React from "react";
import { PeriodRange } from "@linkfluence/models/date";
import ImageClustering from "@radarly/components/widgets/image-clustering";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { useImageClusterWidget } from "@radarly/core/widgets/use-cases";
import { tr } from "@radarly/i18n";
//import { getFakeClustersData } from "@radarly/mock/clusters";
import { Cluster } from "@radarly/models/insights";
import { ClusterFragment } from "@radarly/models/search";
import Empty from "../../empty";
import Loading from "../../loading";

export interface IProps {
  fragment: ClusterFragment;
  className?: string;
  onClick?: (uids: string[]) => void;
  forceReload?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
  period: PeriodRange;
  height?: number;
  clusterView: Cluster;
  onChangeClusterView: (cluster: Cluster) => void;
}

export default function SharedWidgetsPostsImageClustering({
  fragment,
  forceReload,
  onClick,
  className,
  isFullscreen,
  closeFullscreen,
  period,
  height = 350,
  clusterView,
  onChangeClusterView,
}: IProps) {
  const { loading, data } = useImageClusterWidget(fragment, period);
  // DEV is very slow, so use these fake clusters when developping locally
  // const loading = false;
  // const data = getFakeClustersData();
  const locale = useCurrentUserLocale();
  const _onClick = (uids: string[]) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClick(uids);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Empty
        empty={data.total === 0 || !data.clusters}
        emptyMessage={tr(locale, "INSIGHT_PAGE::NO_CLUSTER_DETECTED")}
      >
        <ImageClustering
          clusters={data.clusters}
          locale={locale}
          className={className}
          onClick={_onClick}
          timezone={fragment.request.timezone}
          height={height}
          isFullscreen={isFullscreen}
          clusterView={clusterView}
          onChangeClusterView={onChangeClusterView}
          isReadOnly={!!!onClick}
        />
      </Empty>
    </Loading>
  );
}
